[
  {
    "revision": "2f65ccc25174050c090a28cbd307beed1ccf0dd6",
    "url": "/offline"
  }
]